import {
  call, put, select, all,
} from 'redux-saga/effects';
import { actions as contractsActions } from '../reducers/contracts';
import { sagaNames, handleSagaError } from './index';
import {
  normalizeContracts,
  normalizeContractsById,
} from './normalizers/contractsNormalizer';

const contextStore = (state) => state.main.context;

export const getListContractsStored = state => state.contracts.listContracts;

const listContractsByIdStore = state => state.contracts.listContractsById;

function* attachmentGenerator(attachment) {
  const context = yield select(contextStore);
  const { id: idAttachment } = attachment;
  const data = { idAttachment };
  const module = yield call(() =>
    import("@/adabyron/telcol/consentimientos/permanencia/attach")
  );
  const getPermanenceAttachment = module.getPermanenceAttachment;
  const response = yield call(getPermanenceAttachment, {
    data,
    context,
  });
  return { ...attachment, downloadUrl: response };
}

function* acuerdoGenerator(acuerdo) {
  const { attachments } = acuerdo;
  if (attachments && Array.isArray(attachments) && attachments.length > 0) {
    const newAttachments = yield all(attachments.map((attachment) => {
      return call(attachmentGenerator, attachment)
    }))
    return { ...acuerdo, attachments: newAttachments };
  }
  return acuerdo;
}

function* productoGenerator(producto) {
  const { acuerdos } = producto;
  if (acuerdos && Array.isArray(acuerdos) && acuerdos.length > 0) {
    const newAcuerdos = yield all(acuerdos.map((acuerdo) => {
      return call(acuerdoGenerator, acuerdo);
    }))
    return { ...producto, acuerdos: newAcuerdos };
  }
  return producto;
}

export function* getListContracts({ handlingCode = 0 }) {
  try {
    const context = yield select(contextStore);
    let listContractsStored = yield select(getListContractsStored);

    if (!listContractsStored) {
      const data = {};
      const module = yield call(() =>
        import("@/adabyron/telcol/consentimientos/permanencia")
      );
      const getPermanence = module.getPermanence;

      const listContracts = yield call(getPermanence, {
        data,
        context,
      });
      if (listContracts && Array.isArray(listContracts.productos) && listContracts.productos.length > 0) {
        const tempProduct = yield all(listContracts.productos.map((producto) => {
          return call(productoGenerator, producto);
        }))

        listContracts.productos = tempProduct;
        listContractsStored = normalizeContracts(listContracts);
      }

      yield put(contractsActions.successGetListContracts(listContractsStored || {
        productos: [],
        listPermanences: [],
      }));
    }
  } catch (error) {
    const reducerFailureAction = contractsActions.failureGetListContracts(
      error
    );
    yield handleSagaError(
      "getListContracts",
      error,
      "ERROR",
      handlingCode,
      reducerFailureAction
    );
  }
}

export function* getListContractsById({ handlingCode = 0, productId }) {
  try {
    const context = yield select(contextStore);
    const a = 0
    const listContractsByIdData = yield select(listContractsByIdStore);
    let response = null;
    if (!listContractsByIdData[productId]) {
      const data = { productId };
      const module = yield call(() =>
        import("@/adabyron/telcol/consentimientos/permanencia")
      );
      const getPermanence = module.getPermanence;
      const listContractsById = yield call( getPermanence, {
        data,
        context,
      });
      const listContractsByIdNormalized = normalizeContractsById(
        listContractsById?.datos,
        productId
      );
      response = listContractsByIdNormalized;
    }
    yield put(contractsActions.successGetListContractsById(response));
  } catch (error) {
    const reducerFailureAction = contractsActions.failureGetListContractsById(
      error
    );
    yield handleSagaError(
      "getListContractsById",
      error,
      "ERROR",
      handlingCode,
      reducerFailureAction
    );
  }
}
